import React from "react";

const POPUP_STORAGE_KEY = "popupShownAfterLogin";

type UseTransaksiPopupProps = {
    isAuthenticated: boolean;
    isTrial?: number | null;
    trialFlag10?: 0 | 1;
};

export default function useTransaksiPopup({
    isAuthenticated,
    isTrial,
    trialFlag10,
}: UseTransaksiPopupProps) {
    const [isOpenPopup, setIsOpenPopup] = React.useState(false);

    const openPopup = React.useCallback(() => {
        setIsOpenPopup(true);
    }, []);

    const closePopup = React.useCallback(() => {
        setIsOpenPopup(false);
    }, []);

    React.useEffect(() => {
        const popupShown = localStorage.getItem(POPUP_STORAGE_KEY);

        if (
            isAuthenticated &&
            trialFlag10 === 1 &&
            isTrial === 1 &&
            !popupShown
        ) {
            openPopup();
            localStorage.setItem(POPUP_STORAGE_KEY, "true");
            return;
        }

        closePopup();
    }, [closePopup, isAuthenticated, isTrial, openPopup, trialFlag10]);

    return {
        isOpenPopup,
        closePopup,
    };
}
